import AxiosInterceptor from "../utils/AxiosInterceptor"; // http://localhost:5000

export const productServices = {
  getAllProducts: (value) =>
    AxiosInterceptor().post("/admin/product/getAdminProduct", value),
  approvereject: (value) =>
    AxiosInterceptor().post("/admin/product/approvereject", value),
  updateProductCategory: (value) =>
    AxiosInterceptor().post("/admin/product/updateProductCategory", value),
  createProductByAdmin: (value) =>
    AxiosInterceptor().post("/admin/product/createProductByAdmin", value),
  deleteProductByAdmin: (value) =>
    AxiosInterceptor().post("/admin/product/deleteProductByAdmin", value),
};

export const apiCategory = {
  add: (value) => AxiosInterceptor().post(`/admin/category/create`, value),
  edit: (value) => AxiosInterceptor().post(`/admin/category/update`, value),
  delete: (value) => AxiosInterceptor().post(`/admin/category/delete`, value),
  getAll: (values) => AxiosInterceptor().post(`/admin/category/getAll`, values),
  getSubCategory: (values) =>
    AxiosInterceptor().post(`/admin/category/getByCategory`, values),
  getById: (values) =>
    AxiosInterceptor().post(`/admin/category/getOne`, values),
  changeStatus: (value) =>
    AxiosInterceptor().post("/admin/category/categoryStatus", value),
  getAllSubCategory: (values) =>
    AxiosInterceptor().post(`/admin/category/getAllSubCategory`, values),
  addSubCategory: (value) =>
    AxiosInterceptor().post(`/admin/category/createSubCategory`, value),
  editSubCategory: (value) =>
    AxiosInterceptor().post(`/admin/category/updateSubCategory`, value),
  deleteSubCategory: (value) =>
    AxiosInterceptor().post(`/admin/category/deleteSubCategory`, value),
  getByIdSubCategory: (values) =>
    AxiosInterceptor().post(`/admin/category/getOneSubCategory`, values),
  changeStatusSubCategory: (value) =>
    AxiosInterceptor().post("/admin/category/subCategoryStatus", value),
  category: (value) =>
    AxiosInterceptor().post("/category/categoriesDropdown", value),

  categorySports: (value) =>
    AxiosInterceptor().post("/category/sports/dropdown", value),
};
